import Vue from 'vue'
import Router from 'vue-router'
import Sicherheit from '@/components/Sicherheit/Views/Sicherheit'
import Start from '@/components/Nav/Start'
import Profil from '@/components/Benutzer/Views/Profil'
import Kommunikation from '@/components/Kommunikation/Views/Kommunikation'
import Unterhaltung from '@/components/Unterhaltung/Views/Unterhaltung'
import Gesundheit from '@/components/Gesundheit/Views/Gesundheit'
import Admin from '@/components/Admin/Views/Admin'

Vue.use(Router);

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'sicherheit',
      component: Sicherheit
    },
    {
      path: '/start',
      name: 'start',
      component: Start
    },
    {
      path: '/profil',
      name: 'profil',
      component: Profil
    },
    {
      path: '/kommunikation',
      name: 'kommunikation',
      component: Kommunikation
    },
    {
      path: '/unterhaltung',
      name: 'unterhaltung',
      component: Unterhaltung
    },
    {
      path: '/gesundheit',
      name: 'gesundheit',
      component: Gesundheit
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin
    },
    {
      path: '*',
      redirect: '/start'
    }
  ]
});

router.beforeEach( (to, from, next) => {
  const publicPages = ['/start'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('benutzer');

  if (authRequired && !loggedIn) {
    return next('/start');
  }

  next();
});

export default router